const formHelp = require('../../../helpers/FormHelpMsg');

export const validarCampoPreenchido = (valor, campo) => {
	if (valor === ''){
		formHelp.showHelp(campo, 'Este campo deve ser preenchido.', 'box-input-required');
		return false;
	}
	return true;
};
